<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Switch({
              label: 'Ukryty tytuł',
              modelPath: [this, 'form', 'is_title_hidden']
            }),
            new fields.Input({
              label: 'Tytuł',
              required: true,
              modelPath: [this, 'form', 'title'],
              multilingual: true
            }),
            new fields.WYSIWYG({
              label: 'Tekst',
              modelPath: [this, 'form', 'text'],
              required: true,
              multilingual: true
            })
          ]
        }
      ]
    }
  }
}
</script>
